import { PhoneNumberUtil } from "google-libphonenumber";
import { MAX_DEFAULT_PHONE_LENGTH } from "../../../utils/constants";
import { PhoneNumberType } from "./type";

/**
 * @class PhoneUtil
 * @description This class contains util methods for Phone Number
 */
export default class PhoneUtil {
  static phoneUtil = PhoneNumberUtil.getInstance();
  static defaultPhoneValues: PhoneNumberType = {
    countryCode: "us",
    dialCode: "1",
    phoneNumber: ""
  };

  /**
   * @description This method is used for separating out country code, dial code & number
   * @param phoneNumber
   */
  static getSeparateFieldsForPhoneNo(phoneNumber: string): PhoneNumberType {
    if (!phoneNumber) {
      return this.defaultPhoneValues;
    }
    try {
      const dialCode = this.phoneUtil.parse(phoneNumber).getCountryCode();
      const no = this.phoneUtil.parse(phoneNumber).getNationalNumber();
      const countryCode = this.phoneUtil.getRegionCodeForNumber(this.phoneUtil.parse(phoneNumber));
      return {
        countryCode: `${countryCode}`,
        dialCode: `${dialCode}`,
        phoneNumber: `${no}`
      };
    } catch (e) {}
    return this.defaultPhoneValues;
  }

  /**
   * @description This is used to validate phone number
   * @param number
   * @param required
   */
  static validatePhoneNumber(number: string, required?: boolean) {
    if (!required && !number) {
      return true;
    }
    try {
      if (number.length > MAX_DEFAULT_PHONE_LENGTH || isNaN(parseInt(number))) {
        return false;
      }
      return this.phoneUtil.isValidNumber(this.phoneUtil.parse(number));
    } catch (e) {}
    return false;
  }
}
